import React from "react";
import "./spinner.css";
const Spinner = (props) => {
  return (
    <>
      <div id="overlayspi">
        <div className="loader">
          <div style={{ color: "white", fontSize: "20px", padding: "20px" }}>{props?.message}</div>
          <img src="images/spinner.gif" alt="spinner" />
        </div>
      </div>
    </>
  );
};

export default Spinner;
